import { useEffect, useState } from "react";
import { componentState } from "../../../atoms/componentState";
import { useNavigate } from "react-router-dom";
import { basicInfo, statusInfo } from "../../../interfaces/defaultInterfaces";
import {
  Box,
  Button,
  Flex,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import {
  FaArrowRight,
  FaEye,
  FaPlay,
  FaPlus,
  FaTrash,
  FaListUl,
} from "react-icons/fa";
import Pagination from "../../../defaultComponents/pagination";
import { FiLink } from "react-icons/fi";
import {
  VendaDigitada,
  ItensVendadigitada,
} from "../../../interfaces/comercialInterfaces";
import { dateForListWithHours } from "../../../constants/dataFormat";
import moment from "moment";
import { HamburgerIcon } from "@chakra-ui/icons";
import ModalDeleteVendaDigitada from "./components/modalDeleteConfirmation";
import { refreshGlobal } from "../../../atoms/refreshGlobal";
import { DEPLOY_URL } from "../../../services/api";
import {
  goToAddVendaDigitada,
  goToAddVendaDigitadaCartao,
} from "../../../routes/coordinator";
import { JWTToken } from "../../../routes/privateRoute";
import jwt_decode from "jwt-decode";
import VendasDigitadasApi from "../../../services/vendasDigitadasApi";
import { toast } from "react-toastify";
import { permissions } from "../../../atoms/permissions";
import ModalVendaDigitadaDetail from "./components/modalVendaDigitadaDetail";
import {
  CaptionFormater,
  ToLocaleFormat,
} from "../../../defaultFunctions/formaters";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../../atoms/customColors";
import ModalItensVendaDigitada from "../../../defaultComponents/ModalItensVendaDigitada";

export default function VendasDigitadas() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  // const [cliente, setCliente] = useState(0);
  const [idDelete, setIdDelete] = useState(0);
  const [listaVendaDigitada, setListaVendaDigitada] = useState(
    Array<VendaDigitada>
  );
  const colors = useRecoilState(customColors)[0];

  const [isOpen, setIsOpen] = useState(false);
  const initialValues = {
    clientFilter: 0,
    statusFilter: 0,
    saleTypeFilter: 0,
    initialDateFilter: "",
    finalDateFilter: "",
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);
  const navigate = useNavigate();
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const cliente = Number(jwtToken.idCliente);
  const perms = useRecoilState(permissions)[0];

  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };
  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
    }
  }, [pages]);
  useEffect(() => {}, [
    search,
    currentPage,
    pageSize,
    filtros.statusFilter,
    filtros.saleTypeFilter,
    filtros.clientFilter,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
  ]);
  const setHeaderLocation = useSetRecoilState(componentState);
  useEffect(() => {
    setHeaderLocation("Vendas Digitadas");
  }, []);

  const [openItens, setOpenItens] = useState(false);
  const [itensSelecionados, setItensSelecionados] = useState<
    ItensVendadigitada[]
  >([]);
  async function getLista() {
    try {
      setLoading(true);
      const response = await VendasDigitadasApi.getListaVendasDigitadas(
        currentPage,
        pageSize,
        "",
        cliente
      );
      console.log("response", response);
      setPages(
        Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
      );
      setListaVendaDigitada(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  }
  useEffect(() => {
    getLista();
  }, [pageSize, cliente, currentPage, refreshGlobal]);

  const [openView, setOpenView] = useState(false);
  const [itemView, setItemView] = useState<any>();

  async function sendEmail(token: string) {
    try {
      await VendasDigitadasApi.senEmailWithLinkForPayment(token);
      toast.success("Link enviado para o e-mail com sucesso!");
    } catch (error) {
      console.log("error: ", error);
      toast.error("Não foi possível enviar o e-mail de pagamento!");
    }
  }

  async function sendBioCheck(token: string) {
    try {
      await VendasDigitadasApi.sendBioCheck(token);
      toast.success(
        "Link de validação de biometria enviado para o e-mail com sucesso!"
      );
    } catch (error) {
      console.log("error: ", error);
      toast.error("Não foi possível enviar o e-mail para validação biometria!");
    }
  }

  return (
    <>
      <Flex
        // width={"100%"}
        height={"fit-content"}
        mt={"0.1%"}
        mx="auto"
        py={3}
        bgColor={colors.WHITE}
        px={10}
        shadow={"lg"}
        flexDirection={"column"}
      >
        <Box
          mb={"10px"}
          // width={"100%"}
          height={"fit-content"}
        >
          <Flex alignItems="center">
            <FaPlay color={colors.BLUEMONEDDBUTTONS} size="25px" />
            <Text
              mx={4}
              color={colors.BLUEMONEDDBUTTONS}
              fontSize={35}
              fontWeight={"bold"}
            >
              Fazer uma venda digitada
            </Text>
          </Flex>
        </Box>

        <Flex
          width={"100%"}
          // height={"100%"}
          justifyContent="flex-start"
          my={"20px"}
          // mr={"50px"}
        >
          <Button
            bgColor={colors.BLUEMONEDDBUTTONS}
            color={colors.WHITE}
            fontSize={"1.8vh"}
            onClick={() => {
              goToAddVendaDigitada(navigate);
            }}
            mr={"10px"}
            fontWeight={"bold"}
            isDisabled={
              perms &&
              perms.findIndex(
                (perm: any) =>
                  perm.idPermissoes === 1 ||
                  perm.idPermissoes === 25 ||
                  perm.idPermissoes === 23
              ) !== -1
                ? false
                : true
            }
          >
            <Icon mr={2} as={FaPlus} />
            NOVA VENDA DIGITADA PIX
          </Button>
          <Button
            bgColor={colors.BLUEMONEDDBUTTONS}
            color={colors.WHITE}
            fontSize={"1.8vh"}
            onClick={() => {
              goToAddVendaDigitadaCartao(navigate);
            }}
            fontWeight={"bold"}
            isDisabled={
              perms &&
              perms.findIndex((perm: any) => perm.idPermissoes === 27) !== -1
                ? false
                : true
            }
            // isDisabled={false}
          >
            <Icon mr={2} as={FaPlus} />
            NOVA VENDA DIGITADA CARTÃO
          </Button>
        </Flex>
      </Flex>
      {loading ? (
        <Flex
          width={"100%"}
          height={"73vh"}
          mt={3}
          mx="auto"
          py={3}
          bgColor={colors.WHITE}
          px={8}
          shadow={"lg"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          // overflowY={"scroll"}
        >
          <Spinner size={"lg"} color={colors.VARIANT} />
        </Flex>
      ) : (
        <Flex
          width={"100%"}
          height={"73vh"}
          mt={3}
          mx="auto"
          py={3}
          bgColor={colors.WHITE}
          px={8}
          shadow={"lg"}
          flexDirection={"column"}
          overflowY={"scroll"}
        >
          <TableContainer>
            <Table variant={"striped"}>
              <Thead h="60px" position="sticky" top="0">
                <Tr>
                  <Th
                    w={"300px"}
                    borderRadius={"8px 0 0 8px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Data de Envio
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Cliente
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    E-mail
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    ID da transição
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Valor
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Status
                  </Th>
                  <Th
                    w={"300px"}
                    borderRadius={"0 8px 8px 0"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Opções
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {listaVendaDigitada &&
                  listaVendaDigitada.map((item, index) => {
                    return (
                      <Tr key={index}>
                        <Td
                          textAlign={"center"}
                          borderRadius={"8px 0px 0px 8px"}
                        >
                          {moment(item.atualizadoEm).format(
                            dateForListWithHours
                          )}
                        </Td>
                        <Td textAlign={"center"}>
                          {CaptionFormater(item.nomePagador)}
                        </Td>
                        <Td textAlign={"center"}>{item.emailPagador}</Td>
                        <Td textAlign={"center"}>{item.idTransacaoProvider}</Td>
                        <Td textAlign={"center"}>
                          {ToLocaleFormat(item.valorTotal)}
                        </Td>
                        <Td textAlign={"center"}>
                          <Tooltip
                            label={
                              item.historico[item.historico.length - 1].status
                            }
                            hasArrow
                            bg={colors.ORANGEMONEDD}
                            color="white"
                            placement="auto-start"
                          >
                            {CaptionFormater(item.status)}
                          </Tooltip>
                        </Td>
                        <Td textAlign={"center"} borderRadius={"0 8px 8px 0"}>
                          <Menu>
                            <MenuButton
                              as={IconButton}
                              aria-label="Options"
                              icon={<HamburgerIcon />}
                              bgColor={colors.BLUEMONEDDBUTTONS}
                              color={colors.WHITE}
                              size={"sm"}
                            />
                            <MenuList>
                              {item.permitirPix === false &&
                              item.status.toLowerCase() != "cancelada" ? (
                                <MenuItem
                                  as={"a"}
                                  target={"_blank"}
                                  href={`${DEPLOY_URL}/payment?token=${item.token}`}
                                  // href={`http://localhost:3000/payment?token=${item.token}`}
                                  icon={<FiLink />}
                                >
                                  Link para Pagamento
                                </MenuItem>
                              ) : item.permitirPix === true &&
                                item.status.toLowerCase() != "cancelada" ? (
                                <MenuItem
                                  as={"a"}
                                  target={"_blank"}
                                  href={`${DEPLOY_URL}/pix?token=${item.token}`}
                                  // href={`http://localhost:3000/pix?token=${item.token}`}
                                  icon={<FiLink />}
                                >
                                  Link para PIX
                                </MenuItem>
                              ) : (
                                <></>
                              )}
                              {item.status.toLowerCase() != "cancelada" &&
                                item.bioCheckNeeded != true && (
                                  <MenuItem
                                    onClick={() => {
                                      sendEmail(item.token);
                                    }}
                                    icon={<FaArrowRight />}
                                  >
                                    Enviar link por e-mail
                                  </MenuItem>
                                )}
                              {item.bioCheckNeeded == true && (
                                <>
                                  <MenuItem
                                    onClick={() => {
                                      sendBioCheck(item.token);
                                    }}
                                    icon={<FaArrowRight />}
                                  >
                                    Enviar link de validação de biometria
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      const a = document.createElement("a");
                                      a.href = `https://m2validacao-docs.softkuka.com.br/${item.token}`;
                                      a.target = "_blank";
                                      a.click();
                                    }}
                                    icon={<FaArrowRight />}
                                  >
                                    Link de validação biométrica
                                  </MenuItem>
                                </>
                              )}
                              <MenuItem
                                onClick={() => {
                                  setOpenView(true);
                                  setItemView(item.historico);
                                }}
                                icon={<FaEye />}
                              >
                                Visualizar Histórico
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  setItensSelecionados(item.itens);
                                  setOpenItens(true);
                                }}
                                icon={<FaListUl />}
                              >
                                Visualizar os itens da venda
                              </MenuItem>
                              {item.status == "Nova" ||
                              item.status == "Falha" ? (
                                <MenuItem
                                  onClick={() => {
                                    setIsOpen(true);
                                    setIdDelete(item.id);
                                  }}
                                  icon={<FaTrash />}
                                >
                                  Cancelar Venda Digitada
                                </MenuItem>
                              ) : (
                                <></>
                              )}
                            </MenuList>
                          </Menu>
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </TableContainer>
          <Flex width={"100%"} justifyContent="center" mt={8}>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pages={pages}
              pageSize={pageSize}
            />
            <Select
              value={pageSize}
              onChange={onChangeSize}
              size="sm"
              ml={5}
              maxW="70px"
              borderRadius="6px"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
            </Select>
          </Flex>
          <ModalVendaDigitadaDetail
            isOpen={openView}
            setIsOpen={setOpenView}
            item={itemView}
          />
          <ModalItensVendaDigitada
            isOpen={openItens}
            setIsOpen={setOpenItens}
            itens={itensSelecionados}
          />
          <ModalDeleteVendaDigitada
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            id={idDelete}
            getLista={getLista}
          />
        </Flex>
      )}
    </>
  );
}
